import Envir from '../components/Envir';

const ServiceConfig = {
   URL_RESOURCE : "",
   LOGIN_URL : "",
   ACCOUT_SERVICES_URL : "",
   OCA_SERVICES_URL : "",
   MKT_SERVICES_URL : "",
   //
   USER_PICTURE_URL : "",
   USER_POST_URL : "",
   USER_VIDEO_URL : "",
   USER_THUMBNAIL_URL : "",
   //
   VPS_SERVER_URL_SAVE_POST_INFO : "",
   VPS_SERVER_URL_AI : "",
   VPS_SERVER_URL_DALEE : "",
   VPS_SERVER_URL_ILLUSTRATE : "",
   VPS_SERVER_URL_VIDEO_ILLUSTRATE : "",
   VPS_SERVER_URL_RETRY_VIDEO : "",
   VPS_SERVER_URL_VALIDATE_CODEC : "",
   VPS_SERVER_URL_GET_VIDEO_SETTINGS : "",
   //
   INVOKE_SERVICE_PARMS : {
      headers: {
         "Accept": "application/json, text/javascript, multipart/form-data",
         "Content-Type": "application/json"
      },
      method: 'post'
   }
};

let VPS_SERVER_PROTOCOL;

if (Envir.ENV !== 'prod') {
   ServiceConfig.INVOKE_SERVICE_PARMS.credentials ='include'; // all environments except ios app allow 3rd party cookies
}

if ((Envir.ENV === 'dev') && (Envir.DEV_SERVER)) {
   VPS_SERVER_PROTOCOL = "http://localhost:5000";
}
else {
   VPS_SERVER_PROTOCOL = "https://medeata.com";
}

ServiceConfig.VPS_SERVER_URL_SAVE_POST_INFO = VPS_SERVER_PROTOCOL + "/savePostInfo";
ServiceConfig.VPS_SERVER_URL_AI = VPS_SERVER_PROTOCOL + "/ai";
ServiceConfig.VPS_SERVER_URL_DALEE = VPS_SERVER_PROTOCOL + "/dalee";
ServiceConfig.VPS_SERVER_URL_ILLUSTRATE = VPS_SERVER_PROTOCOL + "/illustrate";
ServiceConfig.VPS_SERVER_URL_VIDEO_ILLUSTRATE = VPS_SERVER_PROTOCOL + "/video";
ServiceConfig.VPS_SERVER_URL_RETRY_VIDEO = VPS_SERVER_PROTOCOL + "/retryVideo";
ServiceConfig.VPS_SERVER_URL_VALIDATE_CODEC = VPS_SERVER_PROTOCOL + "/validateCodec";
ServiceConfig.VPS_SERVER_URL_GET_VIDEO_SETTINGS = VPS_SERVER_PROTOCOL + "/getVideoSettings";

if (Envir.ENV === 'dev') {
   ServiceConfig.URL_RESOURCE = "https://dcmjtk7wr7.execute-api.us-east-2.amazonaws.com/";
   ServiceConfig.USER_PICTURE_URL = "https://ocai.s3.us-east-2.amazonaws.com/prf/";
   ServiceConfig.USER_POST_URL = "https://ocai.s3.us-east-2.amazonaws.com/pst/";
   ServiceConfig.USER_VIDEO_URL = "https://ocai.s3.us-east-2.amazonaws.com/vid/";
   ServiceConfig.USER_THUMBNAIL_URL = "https://ocai.s3.us-east-2.amazonaws.com/thumbnail/";
}
else if (Envir.ENV === 'qa') {
   ServiceConfig.URL_RESOURCE = "https://dcmjtk7wr7.execute-api.us-east-2.amazonaws.com/";
   ServiceConfig.USER_PICTURE_URL = "https://ocai.s3.us-east-2.amazonaws.com/prf/";
   ServiceConfig.USER_POST_URL = "https://ocai.s3.us-east-2.amazonaws.com/pst/";
   ServiceConfig.USER_VIDEO_URL = "https://ocai.s3.us-east-2.amazonaws.com/vid/";
   ServiceConfig.USER_THUMBNAIL_URL = "https://ocai.s3.us-east-2.amazonaws.com/thumbnail/";
}
else if ((Envir.ENV === 'production') || (Envir.ENV === 'prod')) {
   ServiceConfig.URL_RESOURCE = "https://5z2xsnwmf9.execute-api.us-east-2.amazonaws.com/";
   ServiceConfig.USER_PICTURE_URL = "https://ocaiprod.s3.us-east-2.amazonaws.com/prf/";
   ServiceConfig.USER_POST_URL = "https://ocaiprod.s3.us-east-2.amazonaws.com/pst/";
   ServiceConfig.USER_VIDEO_URL = "https://ocaiprod.s3.us-east-2.amazonaws.com/vid/";
   ServiceConfig.USER_THUMBNAIL_URL = "https://ocaiprod.s3.us-east-2.amazonaws.com/thumbnail/";
}

ServiceConfig.LOGIN_URL =  ServiceConfig.URL_RESOURCE + Envir.ENV + "/login";
ServiceConfig.ACCOUT_SERVICES_URL = ServiceConfig.URL_RESOURCE + Envir.ENV + "/accountservices";
ServiceConfig.OCA_SERVICES_URL = ServiceConfig.URL_RESOURCE + Envir.ENV + "/oca";
ServiceConfig.MKT_SERVICES_URL = ServiceConfig.URL_RESOURCE + Envir.ENV + "/mkt";

export default ServiceConfig;